import CloseIcon from "@mui/icons-material/Close";
import {
  Alert,
  Autocomplete,
  Button,
  Card,
  CardActions,
  CardContent,
  Collapse,
  Divider,
  IconButton,
  Modal,
  TextField,
  Typography
} from "@mui/material";
import ErrorIcon from "assets/images/warning-2.svg";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { downloadOptionCSV, downloadOptionExcel_Xls } from "utils/constants";
import { popupStyles } from "./Popup.Style";

const DownloadPoLocalDownloadPopuppup = ({
  title,
  showDownloadModal,
  onCancleClick,
  onDownloadClick,
  setSelectedValue,
  setThrowError,
  throwError,
  throwErrorMessage
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(downloadOptionCSV);
  const [inputValue, setInputValue] = useState("");

  return (
    <Modal
      open={showDownloadModal}
      onClose={onCancleClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={popupStyles.cardStyle}>
        {/* modal header start */}
        <Typography
          variant="h6"
          sx={popupStyles.popupTitle}
          color="text.secondary"
          gutterBottom
        >
          {title}
        </Typography>
        {/* modal header start */}

        <Divider />

        {/* modal content start */}
        <CardContent sx={popupStyles.cardContentStyles}>
          <Collapse in={throwError}>
            {/*Error alert box*/}
            <Alert
              severity="error"
              icon={<img src={ErrorIcon} alt="error" width="20" />}
              sx={popupStyles.alertBox}
              action={
                <IconButton
                  aria-label={t("common.close")}
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setThrowError(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              <Typography sx={popupStyles.alertTextStyle}>
                {throwErrorMessage}
              </Typography>
            </Alert>
          </Collapse>
          <Autocomplete
            id="downloadFileType"
            options={[downloadOptionCSV, downloadOptionExcel_Xls]}
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
              setSelectedValue(newValue);
            }}
            inputValue={inputValue}
            disableClearable={true}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Export Type" />
            )}
          />
        </CardContent>
        {/* modal content end */}

        <Divider />

        {/* modal footer start */}
        <CardActions sx={popupStyles.cardActionStyles}>
          <Button variant="outlined" onClick={() => onCancleClick()}>
            {t("common.close")}
          </Button>
          <Button variant="contained" onClick={() => onDownloadClick()}>
            {t("common.download")}
          </Button>
        </CardActions>
        {/* modal footer start */}
      </Card>
    </Modal>
  );
};

export default DownloadPoLocalDownloadPopuppup;
